import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';


//components
import withLocalization from '~/hoc/withLocalization';
import withRemoveDialog from '~/hoc/withRemoveDialog';
import GenericList from '~/components/GenericList/GenericList';
import Button from '~/components/CustomButton/CustomButton.jsx';
import GenericFilter from '../../../components/GenericList/GenericFilter';
import MemberAvailability from './MemberAvailability';

//elements
import StatusBox from '../../../elements/StatusBox';

//utils
import { shortDateFormat, timeFormat } from '~/utils/dateFormat';
import { statusMap } from '~/utils/normalStatuses';

//assets
import Delete from '~/assets/img/deleting.svg';
import Edit from '~/assets/img/editing.svg';
import CloseModalIcon from '~/assets/img/CloseApproveModalIcon.svg';

import '../../../styles/css/styles.css';
import '~/components/Scheduler/css/style.css';

class ScheduleAvailabilityList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowMemberAvailability: false,
            memberData: null,
            accepting: null,
        }
        this.hideAvailability = this.hideAvailability.bind(this)
    }

    componentWillMount() {
        this.props.scheduleStore.loading = true;
    }

    memberAvailability = (full) => {
        const _memberData = full.availability.map(e => ({ ...e, first_name: full.first_name, last_name: full.last_name }))
        this.setState({
            memberData: _memberData
        }, () => this.setState({ isShowMemberAvailability: true }))
    }

    hideAvailability() {
        this.setState({
            isShowMemberAvailability: false, memberData: null
        })
    }

    handleTableButtonAction = (id, type, data) => {
        const { t } = this.props;
        if (type === 'edit')
            this.props.editRowData(data);
        if (type === 'remove') {
            const str = `${t("Are you sure to delete the availability")}?`;
            confirmAlert({
                title: this.props.t('Confirm to delete'),
                message: str,
                overlayClassName: "custom-confirm-overlay-class",
                buttons: [
                    {
                        label: t('Yes'),
                        onClick: () => {
                            return this.props.scheduleStore.removeAvailability(id).then(res2 => {
                                this.props.scheduleStore.resetLastListLoadTime();
                                return res2;
                            });
                        },
                    },
                    {
                        label: t('No'),
                        onClick: () => { },
                    },
                ],
            });
        }
    }

    handleAccept(id, full) {
        if (full.status === 'approved') return;
        this.setState({
            accepting: {
                id: id,
                count: 1,
                entity: 'availability',
                full: full
            },
        });
    }

    updateAvailabilityStatus(id, value) {
        const { t, commonStore, scheduleStore } = this.props
        let values = {
            status: value,
            comment: value
        }
        scheduleStore.updateAvailabilityStatus(id, values).then(res => {
            if (res) {
                commonStore.addNotification(t('Success'), null, 'success');
                this.setState({ accepting: null }, () => {
                    this.props.scheduleStore.resetLastListLoadTime();
                    this.props.updateAvailabilityStatus();
                })
            }
        }).catch(e => {
            console.error(e);
            return commonStore.addNotification(t('Something went wrong'), null, 'error');
        })
    }

    renderTableActionButtons = (id, full) => {
        const { t, userStore } = this.props;
        const { user_type } = userStore.currentUser;
        const isMember = user_type === 'member';
        const showStatus = !isMember;
        const actionable = showStatus && full.status !== 'approved';
        return (
            <div className="actions-center justify-content-center align-items-center">
                {user_type !== 'member' &&
                    <div
                        className={`status-block status-${full.status || 'active'} 
                            ${!actionable || isMember ? 'cursor-no-drop' : 'cursor-pointer'}`}
                        onClick={() => (showStatus ? this.handleAccept(id, full) : null)}
                    >
                        {t(statusMap[full.status === 'pending' ? 'active' : full.status])}
                    </div>
                }
                <OverlayTrigger
                    key="availability_edit"
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-top">
                            {t('Update Availability')}
                        </Tooltip>
                    }
                >
                    <Button icon_sm fill
                        disabled={full.status !== 'pending'}
                        onClick={() => this.handleTableButtonAction(id, 'edit', full)}>
                        <img src={Edit} alt={"edit"} />
                    </Button>
                </OverlayTrigger>

                <OverlayTrigger
                    key="availability_view"
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-top">
                            {t('View Approved Availability')}
                        </Tooltip>
                    }
                >
                    <Button icon_sm fill
                        disabled={full.status !== 'approved'}
                        onClick={() => this.memberAvailability(full)}>
                        <i className='fa fa-clipboard-check' style={{ fontSize: '19px' }}></i>
                    </Button>
                </OverlayTrigger>

                <OverlayTrigger
                    key="availability_delete"
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-top">
                            {t('Remove Availability')}
                        </Tooltip>
                    }
                >
                    <Button icon_sm_delete fill
                        disabled={full.status === 'approved'}
                        onClick={() => this.handleTableButtonAction(id, 'remove', full)}>
                        <img src={Delete} alt="delete" />
                    </Button>
                </OverlayTrigger>
            </div>
        );
    };

    render() {
        const { t, userStore, commonStore, scheduleStore } = this.props;
        const { loading, availabilityFilters, appliedAvailabilityFilters } = scheduleStore;
        const { user_type } = userStore.currentUser;
        const { memberData, isShowMemberAvailability, accepting } = this.state;
        const dateTimeRules = commonStore.getDateTimeRules();
        return (
            <div>
                <GenericList
                    columns={[
                        {
                            Header: 'Member',
                            id: 'first_name',
                            sortable: false,
                            accessor: ({ first_name, last_name }) => (
                                <span>
                                    {first_name} {last_name}
                                </span>
                            ),
                            maxWidth: 90,
                            minWidth: 80,
                        },
                        {
                            Header: 'Effective dates',
                            id: 'request_type',
                            sortable: false,
                            accessor: ({ request_type, from_date, to_date, }) => (
                                <span>
                                    {request_type === 'repeating' ? t('Repeating')
                                        : (shortDateFormat(from_date, dateTimeRules) + ' | ' + shortDateFormat(to_date, dateTimeRules))}
                                </span>
                            ),
                        },
                        {
                            Header: 'Date submitted',
                            id: 'date_submit',
                            sortable: true,
                            accessor: ({ date_submit }) => date_submit && shortDateFormat(date_submit, dateTimeRules),
                        },
                        {
                            Header: 'Status',
                            id: 'status',
                            sortable: true,
                            accessor: ({ status }) => (
                                <StatusBox status={status || ''} />
                            ),
                            maxWidth: 90,
                            minWidth: 80,
                        },
                        {
                            Header: 'Actions',
                            id: 'actions',
                            sortable: false,
                            accessor: full => this.renderTableActionButtons(full.id, full),
                        },
                    ]}
                    forceReload={this.props.scheduleStore.deleteSuccess}
                    header={(
                        <GenericFilter
                            filters={availabilityFilters}
                            setFilter={(name, value) => this.props.scheduleStore.setAvailabilityFilter(name, value)}
                            hasSearch={user_type !== 'member'}
                            hasDateFilters={true}
                            searchFilterPlaceholder={"Search by employee name"}
                            onFilter={() => this.props.scheduleStore.onAvailabilityFilter()}
                            loading={loading}
                        />
                    )}

                    filters={appliedAvailabilityFilters}
                    lastListLoadTime={this.props.scheduleStore.lastListLoadTime}
                    handlePageChange={(page, isEdit) => this.handlePageChange(page, isEdit)}
                    page={this.props.page}//new page props to maintain page from parent//
                    isPageAddedOrEdited={this.props.isPageAddedOrEdited}//to load same page after edit//
                    requestData={(params) => this.props.scheduleStore.loadAvailabilityList(params)}
                />

                {isShowMemberAvailability &&
                    <Modal dialogClassName="lg bulk-shift-modal" className="lg" size="lg" show onHide={this.hideAvailability}>
                        <Modal.Header className="set_ModalHeader" >
                            <Modal.Title className='w-100 text-center custom-modal-title'>
                                {t('Member Availability')}
                            </Modal.Title>
                            <img
                                src={CloseModalIcon}
                                className="cursor-pointer"
                                alt='close icon'
                                onClick={this.hideAvailability}
                            />
                        </Modal.Header>
                        <Modal.Body>
                            <MemberAvailability obj={memberData} />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button fill wd icon
                                style={{ backgroundColor: 'green' }}
                                onClick={() => this.updateAvailabilityStatus(accepting.id, 'approved')}>
                                {t('Approve')}
                            </Button>
                            <Button fill wd icon
                                style={{ backgroundColor: 'red', marginRight: 30, border: 0 }}
                                onClick={() => this.updateAvailabilityStatus(accepting.id, 'rejected')}>
                                {t('Reject')}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                }
                <Modal size="lg" show={!!accepting} onHide={() => this.setState({ accepting: null })}>
                    <Modal.Header>
                        <Modal.Title>{t('Accept/reject')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close icon'
                            onClick={() => this.setState({ accepting: null })}
                        />
                    </Modal.Header>
                    <Modal.Body>
                        <div className='ms-3'>
                            {!!accepting &&
                                <>
                                    <Row>
                                        <Col xs={4}>
                                            <div>
                                                <p className='fw-bold m-0'>{t("Employee")}</p>
                                                <p>{accepting.full.first_name}&nbsp;{accepting.full.last_name}</p>
                                            </div>
                                        </Col>
                                        <Col xs={4}>
                                            <div>
                                                <p className='fw-bold m-0'>{t("Effective dates")}</p>
                                                <p>{accepting.full.request_type === 'repeating' ? t('Repeating')
                                                    : (shortDateFormat(accepting.full.from_date, dateTimeRules) + ' | ' + shortDateFormat(accepting.full.to_date, dateTimeRules))}
                                                </p>
                                            </div>
                                        </Col>
                                        <Col xs={4}>
                                            <div>
                                                <p className='fw-bold m-0'>{t('Date submitted')}</p>
                                                <p>{shortDateFormat(accepting.full.date_submit, dateTimeRules)}</p>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row style={{ maxHeight: '60vh', overflowY: 'scroll' }}>
                                        {accepting?.full?.availability?.length ?
                                            <div className='table-responsive'>
                                                <table className='table'>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ textAlign: "left" }}>{t("Availability")}</th>
                                                            <th style={{ textAlign: "left" }}>{t("Date")}</th>
                                                            <th style={{ textAlign: "left" }}>{t("Time")}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {accepting.full.availability.map(ele =>
                                                            <tr>
                                                                <td style={{ textAlign: "left" }}>
                                                                    <span style={{ color: ele.availability_type === 'available' ? 'green' : 'red' }}>
                                                                        {ele.availability_type === 'available' ? t("Available") : "Unavailable"}
                                                                    </span>
                                                                </td>
                                                                <td style={{ textAlign: "left" }}>
                                                                    <span>
                                                                        {shortDateFormat(ele.for_date, dateTimeRules)}
                                                                    </span>
                                                                </td>
                                                                <td style={{ textAlign: "left" }}>
                                                                    <span>
                                                                        {ele.from ? `${timeFormat(ele.from)} - ${timeFormat(ele.to)}` : t('Full day')}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            : <span>{t("No data found")}</span>
                                        }
                                    </Row>
                                </>
                            }
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button fill wd icon
                            style={{ backgroundColor: 'green' }}
                            onClick={() => this.updateAvailabilityStatus(accepting.id, 'approved')}>
                            {t('Approve')}
                        </Button>
                        <Button fill wd icon
                            style={{ backgroundColor: 'red', marginRight: 30, border: 0 }}
                            onClick={() => this.updateAvailabilityStatus(accepting.id, 'rejected')}>
                            {t('Reject')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default inject('userStore', 'commonStore', 'scheduleStore')(withLocalization(withRemoveDialog(observer(ScheduleAvailabilityList))));
